/*
 * @Author: Ryan
 * @Date: 2025-12-29
 * @Description: AI Voice Cloning 首屏角色视频数据配置
 */

export interface CharacterVideo {
  id: string;
  name: string;
  thumbnailUrl: string;
  videoUrl: string;
  posterUrl: string;
  script: string;
}

// 角色视频数据配置
// 顺序：盘古、忍者、化妆品、播客、女巫
export const CHARACTER_VIDEOS: CharacterVideo[] = [
  {
    id: 'fantasy-narration',
    name: 'Fantasy Narration',
    thumbnailUrl:
      'https://assets.falcocut.ai/ai-voice-cloning/hero-fantasy-narration.webp',
    videoUrl: 'https://assets.falcocut.ai/ai-voice-cloning/hero-fantasy-narration.mp4',
    posterUrl:
      'https://assets.falcocut.ai/ai-voice-cloning/hero-fantasy-narration-poster.webp',
    script:
      'Ah… there you are. Relax. You made it this far already. Let’s see what you can do next.',
  },
  {
    id: 'brand-narration',
    name: 'Brand Narration',
    thumbnailUrl: 'https://assets.falcocut.ai/ai-voice-cloning/hero-brand-narration.webp',
    videoUrl: 'https://assets.falcocut.ai/ai-voice-cloning/hero-brand-narration.mp4',
    posterUrl:
      'https://assets.falcocut.ai/ai-voice-cloning/hero-brand-narration-poster.webp',
    script:
      'Arigato... FalcoCut. This blade is forged through discipline. This voice is shaped with the same care. Calm. Precise. Ready to be heard.',
  },
  {
    id: 'product-videos',
    name: 'Product Videos',
    thumbnailUrl: 'https://assets.falcocut.ai/ai-voice-cloning/hero-product-videos.webp',
    videoUrl: 'https://assets.falcocut.ai/ai-voice-cloning/hero-product-videos.mp4',
    posterUrl:
      'https://assets.falcocut.ai/ai-voice-cloning/hero-product-videos-poster.webp',
    script: 'Simple. Gentle. Made to care for your skin every day.',
  },
  {
    id: 'podcasts',
    name: 'Podcasts',
    thumbnailUrl: 'https://assets.falcocut.ai/ai-voice-cloning/hero-podcasts.webp',
    videoUrl: 'https://assets.falcocut.ai/ai-voice-cloning/hero-podcasts.mp4',
    posterUrl: 'https://assets.falcocut.ai/ai-voice-cloning/hero-podcasts-poster.webp',
    script: "Let's slow down for a moment and really talk about what matters.",
  },
  {
    id: 'character-voice',
    name: 'Character Voice',
    thumbnailUrl: 'https://assets.falcocut.ai/ai-voice-cloning/hero-character-voice.webp',
    videoUrl: 'https://assets.falcocut.ai/ai-voice-cloning/hero-character-voice.mp4',
    posterUrl:
      'https://assets.falcocut.ai/ai-voice-cloning/hero-character-voice-poster.webp',
    script:
      "Hmm... interesting. This might work better than I expected. Let's see how far we can take it.",
  },
];
